import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const CardSearch = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const Footer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: flex-end;

  div {
    width: 200px;
  }
`;

export const CardUser = styled.div`
  display: flex;
  height: 50px;
  flex-direction: row;
  width: 100%;
`;

export const CardNome: any = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  word-break: break-all;
  margin-right: 12px;
`;

export const CardPontuacao: any = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  word-break: break-all;
`;

export const ContainerLoading: any = styled.div`
display: flex;
justify-content: center;`;
